/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S4_P1Inputs */

const en_guide_large_json_files_s4_p1 = /** @type {(inputs: Guide_Large_Json_Files_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your large JSON file is an array of objects (common for exports and logs), split it into smaller chunks. Process each chunk separately, then combine results. Many command-line tools like <code>jq</code> and <code>split</code> can help with this approach.`)
};

const ko_guide_large_json_files_s4_p1 = /** @type {(inputs: Guide_Large_Json_Files_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대용량 JSON 파일이 객체 배열인 경우(내보내기와 로그에서 흔함), 더 작은 청크로 분할하세요. 각 청크를 별도로 처리한 다음 결과를 합칩니다. <code>jq</code>와 <code>split</code> 같은 커맨드 라인 도구가 이 접근 방식에 도움이 됩니다.`)
};

const ja_guide_large_json_files_s4_p1 = /** @type {(inputs: Guide_Large_Json_Files_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きなJSONファイルがオブジェクトの配列（エクスポートやログに一般的）の場合、小さなチャンクに分割します。各チャンクを個別に処理し、結果を結合します。<code>jq</code>や<code>split</code>などのコマンドラインツールがこのアプローチに役立ちます。`)
};

/**
* | output |
* | --- |
* | "If your large JSON file is an array of objects (common for exports and logs), split it into smaller chunks. Process each chunk separately, then combine resul..." |
*
* @param {Guide_Large_Json_Files_S4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s4_p1 = /** @type {((inputs?: Guide_Large_Json_Files_S4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s4_p1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s4_p1(inputs)
	return ja_guide_large_json_files_s4_p1(inputs)
});